import React from 'react';
import { Grid, GridColumn, GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { Checkbox } from "@progress/kendo-react-inputs";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { DropDownCell } from "./InsuranceMappingsDropDownBox";
import Api from '../../services/api/api';
import './InsuranceMappings.css';

export default class InsuranceMappings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            nameFilter: '',
            unmappedFilter: false,
            unboundFilter: false,
            data: [],
            skip: 0,
            take: 10,
            currentData: [],
            allowableTypes: [],
            lastModifiedItem: '',
            sort: [],
        };
    }

    componentDidMount() {
        this.loadData();
        Api.getAllowableScheduleTypes()
            .then(res => {
                this.setState({
                    allowableTypes: res
                })
            })
            .catch(err => console.log(err));
    }

    handleMappedTypeChange = (e) => {
        Api.saveMappedInsurance(e.dataItem)
            .then(res => {
                this.setState({ lastModifiedItem: e.dataItem.name });
            })
            .catch(err => console.log(err));
    }

    rowRender = (trElement, dataItem) => {

        const trProps = {
            ...trElement.props,
        };

        // animate the change to the row
        if (dataItem.dataItem.name === this.state.lastModifiedItem) {
            trProps.className += " animate-row";
            trProps.key = Math.random();
        }

        var modifiedTr = React.cloneElement(trElement, { ...trProps }, trElement.props.children);

        return modifiedTr;
    }

    handleNameFilterChange = (e) => {
        this.setState({ nameFilter: e.target.value }, this.filterData);
    }

    handleUnmappedFilterChange = (e) => {
        this.setState({ unmappedFilter: e.target.value }, this.filterData);
    }

    handleUnboundFilterChange = (e) => {
        this.setState({ unboundFilter: e.target.value }, this.filterData);
    }

    handlePageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take,
        });
    };

    loadData = () => {
        this.setState({ isLoading: true });

        Api.getInsuranceMappings().then((results) => {
            results.forEach(item => {
                if (item.modifiedDate) {
                    item.modifiedDate = new Date(item.modifiedDate);
                }
            });
            this.setState({ data: results, isLoading: false }, this.filterData);
        });
    }

    filterData = () => {
        const filters = [];

        if (this.state.nameFilter) {
            filters.push({ field: 'name', operator: 'contains', value: this.state.nameFilter, ignoreCase: true });
        }

        if (this.state.unmappedFilter) {
            filters.push({ field: 'isMapped', operator: 'eq', value: false });
        }

        if (this.state.unboundFilter) {
            filters.push({ field: 'isBoundToSchedule', operator: 'eq', value: false });
        }

        const filteredData = filterBy(this.state.data.slice(), {
            logic: 'and',
            filters
        });

        // If the filter has shrunk the dataset smaller than the current page, reset to the last page
        if (filteredData.length < this.state.skip) {
            let page = Math.trunc((filteredData.length - 1) / this.state.take) + 1;
            this.setState({ skip: (page - 1) * this.state.take });
        }

        this.setState({
            currentData: filteredData
        });

        //clear lastModifiedItem
        this.setState({ lastModifiedItem: "" });
    }

    renderIsBoundCell = (props) => {
        const field = props.field || "";
        const value = props.dataItem[field];

        return (<td
            colSpan={props.colSpan}
            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
            {...{
                [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
            }}
        ><h5 className="text-center">
                {value ? (<span style={{ color: 'green' }} className="bi bi-check-circle-fill" />) : <span style={{ color: 'red' }} className="bi bi-x-circle-fill" />}
            </h5>
        </td>);
    }

    allowableTypesWithMapped = (types, mappedType) => {
        if (mappedType === null) {
            return types
        }
        else if (types.some(x => x.name === mappedType)) {
            return types;
        } else {
            return [{ name: mappedType }, ...types];
        }
    }

    render() {
        const loadingPanel =
            <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image"></div>
                <div className="k-loading-color"></div>
            </div>

        return (
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h1 className="page-header">Edit Insurance Mappings</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="card shadow">
                        <div className="card-body">
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-sm-1">
                                        <label htmlFor="filter" className="col-form-label">Filter</label>
                                    </div>
                                    <div className="col-sm-3">
                                        <input id="filter" className="form-control" value={this.state.nameFilter} onChange={this.handleNameFilterChange} />
                                    </div>
                                    <div className="col-sm-2">
                                        <Checkbox checked={this.state.unmappedFilter} onChange={this.handleUnmappedFilterChange} label="Show Unmapped Only" />
                                    </div>
                                    <div className="col-sm-2">
                                        <Checkbox checked={this.state.unboundFilter} onChange={this.handleUnboundFilterChange} label="Show Unbound Only" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.isLoading ? loadingPanel :
                    <div className="row">
                        <div className="card shadow">
                            <div id="insurancemapping-grid" className="card-body">
                                <Grid
                                    data={orderBy(this.state.currentData, this.state.sort).slice(this.state.skip, this.state.take + this.state.skip)}
                                    skip={this.state.skip}
                                    take={this.state.take}
                                    total={this.state.currentData.length}
                                    pageable={true}
                                    onPageChange={this.handlePageChange}
                                    rowRender={this.rowRender}
                                    sortable={true}
                                    sort={this.state.sort}
                                    onSortChange={(e) => {
                                        this.setState({
                                            sort: e.sort,
                                        });
                                    }}
                                >
                                    <GridColumn field="name" sortable={true} title="Insurance" />
                                    <GridColumn field="defaultType" sortable={true} title="Default Type" />
                                    <GridColumn field="mappedType" sortable={true} title="Mapped Type" cell={(props) => { return DropDownCell(props, this.allowableTypesWithMapped(this.state.allowableTypes, props.dataItem.mappedType), this.handleMappedTypeChange); }} />
                                    <GridColumn field="isBoundToSchedule" sortable={true} title="Is Bound To Schedule" cell={this.renderIsBoundCell} />
                                    {/* <GridColumn field="modifiedDate" sortable={true} filter="date" format="{0:MM/dd/yyyy}" title="Modified Date" /> */}
                                    {/* <GridColumn field="modifiedBy" sortable={true} title="Modified By" /> */}
                                </Grid>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}